import { User } from "../../models/User";
import { LocationLog } from "../../models/LocationLog";
import { PermitAssignment } from "../../models/PermitAssignment";

// Constants
export const UPDATE_PERMIT_ASSIGNEE = "UPDATE_PERMIT_ASSIGNEE";
export const LOAD_PERMIT_SUBMITTER_SUCCESSFUL = "LOAD_PERMIT_SUBMITTER_SUCCESSFUL";
export const UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL = "UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL";

// Action Types
interface UpdatePermitAssigneeAction {
    type: typeof UPDATE_PERMIT_ASSIGNEE;
    assignment: PermitAssignment;
}

interface LoadPermitSubmitterSuccessfulAction {
    type: typeof LOAD_PERMIT_SUBMITTER_SUCCESSFUL;
    user: User;
}

interface updatePermitLastAccessSuccessfulAction {
    type: typeof UPDATE_PERMIT_LAST_ACCESS_SUCCESSFUL;
    locationLog: LocationLog;
    permitId: string;
}

export type PermitDetailsTabActionTypes =
    | UpdatePermitAssigneeAction
    | LoadPermitSubmitterSuccessfulAction
    | updatePermitLastAccessSuccessfulAction;
